import React from 'react'
import PropTypes from 'prop-types'

export const Input = props => {
  const { name, type, classes, onChange, placeholder, error, rtl, id } = props

  return (
    <input
      type={type}
      value={name}
      style={error ? { border: '1px solid #FF624C', color: '#FF624C' } : {}}
      onChange={onChange}
      placeholder={placeholder}
      className={classes}
      dir={rtl ? 'rtl' : 'ltr'}
      id={id}
      autoComplete="off"
    />
  )
}

Input.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  onChange: PropTypes.func,
}
